<app-component-html-template
  [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="packagingAid"
  [form]="form"
  [componentSubtypes]="componentSubtypes"
  [packagingComponentType]="packagingComponentType.PackagingAid"
  [callerId]="callerId"
  [isPreview]="isPreview"
  [isTracked]="isTracked"
  [isFormLocked]="isFormLocked"
  [historyVersions]="historyVersions"
  [spinnerActive]="spinnerActive"
  [canEditForm]="canEditForm"
  [isUserValidator]="isUserValidator"
  [isEditPermitted]="isEditPermitted"
  [imageSource]="imageSource"
  [componentTypeSelectionLabel]="'component.fields.ofPackagingAid' | transloco"
  (submitted)="onComponentSubmit($event)"
  [isInternallyTracked]="isInternallyTracked"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [isCreatingDataExchangeRequest]="isCreatingDataExchangeRequest()"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (historicVersionChanged)="onHistoryVersionChange($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (exportClicked)="exportDataset($event)"
  (reportsClicked)="onReportsClicked($event)"
  (createDataExchangeRequestClicked)="onCreateDataExchangeRequestClicked($event)"
  (historicVersionClicked)="loadHistoryVersions(packagingAid.id)"
  (versionRenamed)="changePackAidVersionName($event)"
  [isHistory]="isHistory"
  [hasUnsavedChanges]="hasUnsavedChanges()">
  <h1 header>{{ 'component.packagingAid' | transloco }}</h1>

  <div doc>
    <app-doc-upload-section [(areaDto)]="packagingAid.docArea" [isEditable]="canEditForm" [ppwrRelevant]="relevantAnalysisTypes.ppwrRelevant"> </app-doc-upload-section>
  </div>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="packagingAid.images" (filesEdited)="onFilesEdited()"> </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="packagingAid.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="packagingAid.documents" (filesEdited)="onFilesEdited()"> </app-pdf-upload>
  </div>
</app-component-html-template>
